import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'
import { routes } from '../../routes'
import { useLocation } from 'react-router-dom'
import { Home2OutlineIcon } from '../AppIcon'
import { inject, observer } from 'mobx-react'

const findRouteByUrl = url => {
  return routes.find(route => route.path === url) ||
    routes.find(route => {
      if (!route.path.includes('*')) return false
      const basePath = route.path.replace('*', '')
      return url === basePath || url.startsWith(`${basePath}/`)
    })
}

const SimpleBreadCrumbV2 = props => {
  const { title, quarter, myDocumentStore } = props
  const location = useLocation()

  const isHome = useMemo(
    () => location.pathname === '/dashboard' || location.pathname === '/',
    [location.pathname]
  )

  const pathSnippets = useMemo(
    () =>
      location !== undefined ? location.pathname.split('/').filter(i => i) : [],
    [location.pathname]
  )

  const baseBreadcrumbItems = useMemo(() => {
    const matchedRoutes = pathSnippets
      .map((_, index) => `/${pathSnippets.slice(0, index + 1).join('/')}`)
      .map(url => {
        const route = findRouteByUrl(url)
        return route ? { ...route, breadcrumbPath: url } : route
      })
      .filter(route => route)
      .filter(
        (route, index, array) =>
          array.findIndex(item => item.path === route.path) === index
      )

    if (title === 'Báo cáo định kỳ' || title === 'Báo cáo đột xuất') {
      return matchedRoutes.map((route, index, array) => {
        let path = route.path
        if (
          route.path === '/report/periodic' ||
          route.path === '/report/extraordinary'
        ) {
          path += location.search
        }
        const name =
          index === array.length - 1 ? `${route.name} - ${quarter}` : route.name
        return (
          <Breadcrumb.Item key={path}>
            <Link to={path}>{name}</Link>
          </Breadcrumb.Item>
        )
      })
    }

    return matchedRoutes.map(route => {
      const handleClick = () => {
        if (route.path.includes('/my-document') && myDocumentStore) {
          myDocumentStore.setCurrentParentId('')
        }
      }
      return (
        <Breadcrumb.Item key={route.path}>
          <Link to={route.breadcrumbPath} onClick={handleClick}>
            {route.name}
          </Link>
        </Breadcrumb.Item>
      )
    })
  }, [location.search, pathSnippets, quarter, title, myDocumentStore])

  let extraBreadcrumbItems = baseBreadcrumbItems
  if (location.pathname.includes('/my-document') && myDocumentStore?.breadcrumb?.length > 0) {
    const dynamicItems = myDocumentStore.breadcrumb.map((item, index) => {
      const isLast = index === myDocumentStore.breadcrumb.length - 1
      return (
        <Breadcrumb.Item key={`doc-${item.id || 'root'}`}>
          {isLast ? (
            <span>{item.name}</span>
          ) : (
            <a onClick={() => myDocumentStore.setCurrentParentId(item.id)}>{item.name}</a>
          )}
        </Breadcrumb.Item>
      )
    })
    extraBreadcrumbItems = extraBreadcrumbItems.concat(dynamicItems)
  }

  const breadcrumbItems = useMemo(
    () =>
      [
        <Breadcrumb.Item key="home" className="breadcrumb-home-icon">
          <Link to="/dashboard">
            <Home2OutlineIcon className="breadcrumb-home-svg" />
          </Link>
        </Breadcrumb.Item>,
      ].concat(extraBreadcrumbItems),
    [extraBreadcrumbItems]
  )

  if (isHome) {
    return (
      <p style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '0px' }}>
        Dashboard
      </p>
    )
  }

  return (
    <Breadcrumb
      separator={<span className="breadcrumb-separator">/</span>}
      className="app-breadcrumb">
      {breadcrumbItems}
    </Breadcrumb>
  )
}

SimpleBreadCrumbV2.propTypes = {
  quarter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  myDocumentStore: PropTypes.object,
}

export default inject('myDocumentStore')(observer(SimpleBreadCrumbV2))
